import { useState, useCallback } from 'react';

const usePopoverState = (isOpen = false) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState<boolean>(isOpen);

  const [referencePopoverElement, setReferencePopoverElement] =
    useState<HTMLElement | null>(null);

  const togglePopover = useCallback<() => void>(() => {
    setIsPopoverOpen((prevVal) => !prevVal);
  }, [setIsPopoverOpen]);

  const closePopover = useCallback<() => void>(() => {
    setIsPopoverOpen(false);
  }, [setIsPopoverOpen]);

  const openPopover = useCallback<() => void>(() => {
    setIsPopoverOpen(true);
  }, [setIsPopoverOpen]);

  return {
    isPopoverOpen,
    referencePopoverElement,
    referencePopoverCallbackRef: setReferencePopoverElement,
    togglePopover,
    closePopover,
    openPopover
  };
};

export default usePopoverState;
